// @flow
import { createAction } from 'redux-action';

export const SELECT_PRODUCT = 'marketplace/search/select-product';

export const selectProduct = createAction(SELECT_PRODUCT);
